@import '~@s-ui/theme/lib/settings-compat-v7/index';
@import '~@s-ui/theme/lib/index';
@import '~@adv-mt/mt-theme/lib/motor';

@import '~@adv-mt/mt-form-make/lib/index';
@import '~@adv-mt/mt-form-model/lib/index';
@import '~@adv-mt/mt-list-latest-models/lib/index';
@import '~@adv-mt/mt-section-basic/lib/index';
@import '~@adv-mt/mt-title-basic/lib/index';
@import '~@adv-mt/mt-layout-basic/lib/index';

.mt-MakesDistributor {
  background-color: $c-white;
  border-radius: $bdrs-l;
  box-shadow: $bxsh-m;
  margin-bottom: $m-xl;
  padding: $p-l;

  &Filter {
    &Wrapper {
      background-color: $c-white;
      border-radius: $bdrs-l;
      box-shadow: $bxsh-m;
      margin-bottom: $m-xl;
      padding: $p-xl;
    }

    &Title {
      margin-bottom: $m-l;
    }
  }

  &Filters {
    @include media-breakpoint-up(m) {
      align-items: flex-start;
      display: grid;
      grid-gap: $g-l;
      grid-template-columns: 2fr 2fr 1fr;
    }
  }

  &Form {
    &Button {
      margin-top: $m-l;
      width: 100%;
    }
    &Model {
      margin-bottom: $m-l;
    }
    &Make {
      margin-bottom: $m-l;
      &Errors {
        position: relative;
      }
    }
  }
}
